<template>
  <v-fade-transition mode="out-in">
    <v-row justify="center" v-if="loading" style="height: 200px;" align="center">
      <v-progress-circular indeterminate size="56" />
      <v-col cols="12" class="text-center heading custom-color font-weight-medium">Loading...</v-col>
    </v-row>
    <slot v-else></slot>
  </v-fade-transition>
</template>

<script>
export default {
  props: {
    loading: Boolean,
  },
};
</script>
